// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"282":"views-app","768":"App"}[chunkId] + "." + {"282":"959182c6","768":"1d3a8164"}[chunkId] + ".chunk.css";
};